import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const ScrollReveal = ({ 
  children, 
  delay = 0,
  direction = 'up', // up, down, left, right
  className = ''
}) => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  const directionClasses = {
    up: 'translate-y-8',
    down: '-translate-y-8',
    left: 'translate-x-8',
    right: '-translate-x-8',
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className} ${
        isVisible
          ? 'opacity-100 translate-y-0 translate-x-0'
          : `opacity-0 ${directionClasses[direction]}`
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
